import * as React from "react";
import { Component } from "react";
import { UncontrolledTooltip } from "reactstrap";

interface GlmIdProp {
  value: string;
}

interface GlmIdState {
  id: string;
  collapsed: boolean;
  tooltip: string;
}

export default class GlmId extends Component<GlmIdProp, GlmIdState> {
  element?: HTMLTextAreaElement;

  constructor(props: GlmIdProp) {
    super(props);

    this.state = {
      // A DICOM UID has dots, which are not valid in a CSS selector: the tooltip finds its target with one.
      id: "GlmId-" + props.value.replace(/[^A-Za-z0-9_-]/g, "_"),
      collapsed: true,
      tooltip: props.value,
    };
  }

  copy() {
    this.setState({ collapsed: false }, () => {
      if (this.element) {
        this.element.select();
        const res = document.execCommand("copy");

        if (res) {
          this.setState({
            collapsed: true,
            tooltip: "L'id a été copiée",
          });
        } else {
          this.setState({ collapsed: true });
        }
      }
    });
  }

  render() {
    return (
      <span>
        <span onClick={this.copy.bind(this)} id={this.state.id} className="cursor-pointer">
          {this.props.value.substring(0, 4) +
            ".." +
            this.props.value.substring(this.props.value.length - 4, this.props.value.length)}
          <UncontrolledTooltip placement="top" target={this.state.id}>
            {this.state.tooltip}
          </UncontrolledTooltip>
        </span>
        <textarea
          ref={(elt) => (this.element = elt)}
          hidden={this.state.collapsed}
          value={this.props.value}
          readOnly={true}
          style={{ position: "absolute", width: "1px", height: "1px" }}
        />
      </span>
    );
  }
}
